import React from "react";
import { Link, graphql } from "gatsby";
import classNames from "classnames";

export const ParagraphLinks = ({ node }) => {
  if (!node || !node?.field_link) return null;
  const linkClasses = classNames(
    "btn",
    node?.field_cta_colour ? `btn-${node?.field_cta_colour}` : "btn-white",
    node?.field_link?.options?.attributes?.class,
    node?.field_icon_type
  );

  return (
    <Link
      to={node?.field_link?.url}
      className={linkClasses}
      target={node?.field_link?.options?.attributes?.target || "_self"}
      rel={node?.field_link?.options?.attributes?.rel}
      aria-label={node?.field_link?.options?.attributes?.aria_label}
    >
      {node?.field_link?.title}
    </Link>
  );
};

export const fragment = graphql`
  fragment ParagraphLinks on paragraph__links {
    field_link {
      url
      title
      options {
        attributes {
          aria_label
          class
          rel
          target
        }
      }
    }
    field_cta_colour
    field_icon_type
  }
`;

export default ParagraphLinks;
